import React, { useState, useEffect } from "react";
import { useNavigate } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import {
  AppBar,
  Toolbar,
  Typography,
  IconButton,
  Box,
  Drawer,
  List,
  ListItem,
  ListItemText,
  ListItemIcon,
  Collapse,
  Badge,
  Button,
  Menu,
  MenuItem,
  BottomNavigation,
  BottomNavigationAction,
  Paper, Tooltip, Avatar, Container
} from "@mui/material";
import {
  Menu as MenuIcon,
  ShoppingBag,
  Close,
  ExpandLess,
  ExpandMore,
  Home,
  Logout,
  Info,
  AddShoppingCart, SettingsSuggest, BarChart, AcUnit, NavigateNext, ArrowDropUp, ArrowDropDown
} from "@mui/icons-material";
import PersonIcon from '@mui/icons-material/Person';
import logo from './images/logo_triumph.png'
import { useGetShoppingBagMutation } from "./services/orders";
import { useGetInforMutation } from './services/auth';
import { setOrderQty } from './features/authSlice';
let pageLoaded = false;
export default function ResponsiveAppBar2() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [mobileOpen, setMobileOpen] = useState(false);
  const orderQty = useSelector(state => state.authUser.orderQty);
  const [getShoppingBag, shoppingBagResult] = useGetShoppingBagMutation();
  const [getInfor, inforResult] = useGetInforMutation();
  // Desktop submenu handling
  const [anchorEl, setAnchorEl] = useState(null);
  const [openMenu, setOpenMenu] = useState(null);
  const [typeMenu, setTypeMenu] = useState("menu");
  const [showMenu, setShowMenu] = React.useState(true);
  const [menuItems, setMenuItems] = React.useState([]);
  const [shopping, setShopping] = React.useState(0);
  
  const user = JSON.parse(window.localStorage.getItem('user')||"{}");
  const infor = JSON.parse(window.localStorage.getItem('infor')||"{}");
  
  useEffect(() => {
    if(shoppingBagResult.data)
    {
      const dt = JSON.parse(shoppingBagResult.data);
      dispatch(setOrderQty(dt.length));
      window.localStorage.setItem('orderItems', JSON.stringify(dt));
    }
  }, [shoppingBagResult]);

  useEffect(() => {
    if(!pageLoaded){
      pageLoaded = true;
      const functions = JSON.parse(user.functions||"[]");
      if(functions.find(f=>f.Form == "orders"))
        setShopping(1);

      const lstGroup = [...new Set(functions.map(item => item.Group))];
      const mnItems = lstGroup.map(label=>{
        return {
          label: label,
          children: functions.filter(f=>f.Group == label)
        }
      });
      setMenuItems(mnItems);
      getShoppingBag();
      getInfor();
    }
  }, []);
  
  const handleOpenMenu = (event, menu) => {
    setAnchorEl(event.currentTarget);
    setOpenMenu(menu);
  };
  const handleCloseMenu = () => {
    setAnchorEl(null);
    setOpenMenu(null);
  };
  const handleNavigate = (path) => {
    navigate(path);
    handleCloseMenu();
  };
  const handleNavigateMobile = (path) => {
    navigate(path);
    setMobileOpen(false);
  };
  const handleLogout = () => {
    window.localStorage.clear();
    navigate("login", { replace: true });
  };

  // Mobile submenu expand/collapse
  const [openMobileSub, setOpenMobileSub] = useState(null);
  const handleToggleMobileSub = (menu) => {
    setOpenMobileSub(openMobileSub === menu ? null : menu);
  };

  // Bottom navigation state
  const [bottomValue, setBottomValue] = useState(0);

  const MeTag = () => 
    <Box sx={{ display: "flex", flexDirection: "column" }}>
      <Typography sx={{ flexGrow: 1, fontWeight: "bold", ml: 1 }}>
        TÊN: {user.fullname}
      </Typography>
      <Typography sx={{ flexGrow: 1, fontWeight: "bold", ml: 1 }}>
        CODE: {user.username}
      </Typography>
      {shopping ?
        <Typography sx={{ flexGrow: 1, ml: 1 }}>
          Còn lại: {(infor.CASHREMAIN||0).toLocaleString()}₫
        </Typography> : ''
      }
      <List sx={{ mt: "auto" }}>
        <React.Fragment key={"Logout"}>
          <ListItem
            button
            onClick={() =>handleLogout()}
          >
            <ListItemIcon><Logout /></ListItemIcon>
            <ListItemText primary={"Logout"} />
          </ListItem>
        </React.Fragment>
      </List>
    </Box>

  const toggleAppBar = () => {
    setShowMenu(!showMenu);
  };

  return (
    <>
      <IconButton
        size="small"
        onClick={toggleAppBar}
        color="inherit"
        sx={{
          position: 'fixed', left: '50%', top: -10, zIndex: 1300, display: { xs: 'none', md: 'block' }
        }}
        title={showMenu ? "hide menu bar" : "show menu bar"}
      >
        {showMenu ? <ArrowDropUp style={{color: 'orange'}} /> : <ArrowDropDown style={{color: 'orange'}} />}
      </IconButton>
      {/* Desktop AppBar */}
      <AppBar
        position="sticky"
        color="inherit"
        sx={{
          boxShadow: '0 5px 10px #f4ebebff', px: { xs: 1, md: 1 }, backgroundColor: '#fffafaff',
          display: { xs: "none", md: showMenu ? "flex" : "none" }, // hide on mobile
        }}
      >
        <Toolbar disableGutters variant='dense' 
          sx={{ minHeight: 50, height: 50, display: "flex", justifyContent: "space-between" }}>
          {/* Logo */}
          <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
            <Box component="img" src={logo} onClick={()=>navigate('home')}
              sx={{ height: 40, width: 100, mr: 1, cursor: "pointer" }}/>
            {/* Desktop Menu */}
            <Box sx={{ display: "flex", alignItems: "left", gap: 1 }}>
              {menuItems.map((item) =>
                item.children ? (
                  <Button
                    key={item.label}
                    onClick={(e) => handleOpenMenu(e, item.label)}
                  >
                    {item.label}
                  </Button>
                ) : (
                  <Button key={item.label}>{item.label}</Button>
                )
              )}
            </Box>

            {/* Submenus */}
            {menuItems.map(
              (item) =>
                item.children && (
                  <Menu
                    key={item.label}
                    anchorEl={anchorEl}
                    open={Boolean(anchorEl) && openMenu === item.label}
                    onClose={handleCloseMenu}
                  >
                    {item.children.map((sub) => (
                      <MenuItem key={sub.Form} onClick={() => handleNavigate(sub.Form)}>
                        {sub.Name}
                      </MenuItem>
                    ))}
                  </Menu>
                )
            )}
          </Box>

          {/* Cart, Me */}
          <Box sx={{ display: "flex", alignItems: "center" }}>
            {shopping?
            <Box sx={{ flexGrow: 0 }}>
              <Tooltip title="Giỏ Hàng">
                <IconButton color="inherit" sx={{ mr: 2 }} onClick={() => handleNavigate("/cart")}>
                  <Badge badgeContent={orderQty||0} color="primary">
                    <ShoppingBag style={{color: '#f38e21ff'}} />
                  </Badge>
                </IconButton>
              </Tooltip>
            </Box>:''}
            <Box sx={{ flexGrow: 0 }}>
              <Tooltip title="Tài Khoản">
                <IconButton 
                  onClick={() => {setTypeMenu("me"); setMobileOpen(true)}}
                  sx={{ p: 0 }}>
                  <Avatar alt="Remy Sharp" sx={{ p: 0, width: 33, height: 33 }}><PersonIcon style={{color: '#2196f3'}}/></Avatar>
                </IconButton>
              </Tooltip>
            </Box>
          </Box>
        </Toolbar>
      </AppBar>

      {/* Mobile Drawer (for full menu) */}
      <Drawer
        anchor="right"
        open={mobileOpen}
        onClose={() => setMobileOpen(false)}
        sx={{
          display: { xs: "block", md: "block" },
          "& .MuiDrawer-paper": {
            width: 300,
            height: "auto",                 // <-- make it auto height
            maxHeight: "100vh",              // optional: limit height
            top: {xs: "auto", md: 0},                    // prevent from sticking to top
            bottom: {xs: 0, md: "auto"},                      // attach to bottom (floating up)
            borderTopLeftRadius: {xs: 12, md: 0},        // rounded look
            borderBottomLeftRadius: {xs: 0, md: 12},
            boxShadow: 6,
          },
        }}
      >
        <Box sx={{
            width: "250",
            height: "100%",             // full height
            // p: 2,
            display: "flex",
            flexDirection: "column",    // vertical layout
            justifyContent: "space-between", // space between header and list
          }}>
          <Box sx={{ display: "flex", justifyContent: "space-between", mb: 2, p: 2, borderBottom: '1px solid #f6dede' }}>
            <Box component="img" src={logo}
              sx={{ height: 40, width: 100, mr: 1 }}/>
            <IconButton onClick={() => setMobileOpen(false)}>
              <Close />
            </IconButton>
          </Box>
          {/* logo or account info */}
          {typeMenu === "me" ? <MeTag /> :
          <List sx={{ mt: "auto" }}>
            {menuItems.map((item) => (
              <React.Fragment key={item.label}>
                <ListItem
                  button
                  onClick={() =>
                    item.children
                      ? handleToggleMobileSub(item.label)
                      : setMobileOpen(false)
                  }
                >
                  {
                    item.label==="Orders"?<ListItemIcon><AddShoppingCart /></ListItemIcon>
                    :item.label==="System"?<ListItemIcon><SettingsSuggest /></ListItemIcon>
                    :item.label==="Reports"?<ListItemIcon><BarChart /></ListItemIcon>
                    :<ListItemIcon><AcUnit /></ListItemIcon>
                  }
                  <ListItemText primary={item.label} />
                  {item.children &&
                    (openMobileSub === item.label ? (
                      <ExpandLess />
                    ) : (
                      <ExpandMore />
                    ))}
                </ListItem>
                {item.children && (
                  <Collapse
                    in={openMobileSub === item.label}
                    timeout="auto"
                    unmountOnExit
                  >
                    <List component="div" disablePadding>
                      {item.children.map((sub) => (
                        <ListItem
                          button
                          key={sub.Form}
                          sx={{ pl: 4 }}
                          onClick={() => handleNavigateMobile(sub.Form)}
                        >
                          <ListItemIcon><NavigateNext /></ListItemIcon>
                          <ListItemText primary={sub.Name} />
                        </ListItem>
                      ))}
                    </List>
                  </Collapse>
                )}
              </React.Fragment>
            ))}
          </List>}
        </Box>
      </Drawer>

      {/* Mobile Bottom Navigation */}
      <Paper
        sx={{
          position: "fixed",
          bottom: 0,
          left: 0,
          right: 0,
          display: { xs: "block", md: "none" },
          zIndex: 5
        }}
        elevation={3}
      >
        <BottomNavigation
          showLabels
          value={bottomValue}
          onChange={(event, newValue) => setBottomValue(newValue)}
        >
          <BottomNavigationAction label="Trang Chủ" icon={<Home />} onClick={()=>navigate('home')} />
          <BottomNavigationAction label="Danh Mục" icon={<MenuIcon />}
            onClick={() => {setTypeMenu("menu"); setMobileOpen(true)}} />
          {/* {menuItems.map((item, index) => (
            <BottomNavigationAction
              key={item.label}
              label={item.label}
              icon={item.icon}
              onClick={() => item.children && setMobileOpen(true)}
            />
          ))} */}
          {shopping?
          <BottomNavigationAction
            label="Giỏ Hàng" onClick={() => handleNavigate("/cart")}
            icon={
              <Badge badgeContent={orderQty||0} color="primary">
                <ShoppingBag />
              </Badge>
            }
          />:''}
          <BottomNavigationAction label="Tài Khoản" icon={<PersonIcon />}
            onClick={() => {setTypeMenu("me"); setMobileOpen(true)}} />
        </BottomNavigation>
      </Paper>
    </>
  );
}
